export const SITE_NAME = "TV13";
export const SITE_TAGLINE = "Doğru Bilgi, Güçlü Yayın";
export const SITE_TITLE = `${SITE_NAME} — ${SITE_TAGLINE}`;
export const SITE_DESCRIPTION =
  "TV13 — haberden spora, kültürden sanata hayatın her alanında güvenilir içerikler sunan dijital yayın platformu.";

export function formatPageTitle(page, { admin = false } = {}) {
  if (!page) return admin ? `${SITE_NAME} Admin` : SITE_TITLE;
  const suffix = admin ? `${SITE_NAME} Admin` : SITE_NAME;
  return `${page} | ${suffix}`;
}

export const ROUTE_TITLES = {
  "/": "Ana Sayfa",
  "/hakkimizda": "Hakkımızda",
  "/programlar": "Programlarımız",
  "/videolar": "Program Videoları",
  "/canli-yayin": "Canlı Yayın",
  "/iletisim": "İletişim",
  "/sss": "Sıkça Sorulan Sorular",
  "/kullanim-kosullari": "Kullanım Koşulları",
  "/gizlilik-politikasi": "Gizlilik Politikası & KVKK",
  "/admin/login": "Giriş",
  "/admin/programs": "Programlar",
  "/admin/videos": "Videolar",
  "/admin/live": "Canlı Yayınlar",
};
